import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  phoneNumber: null,
  phoneNumbers: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const phoneNumberReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.PHONENUMBER_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.PHONENUMBER_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.PHONENUMBER_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default phoneNumberReducer;
